/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CaseStateUpdatesListResponse } from '../../models/case-state-updates-list-response';

export interface GetCaseStateHistory$Params {

/**
 * Id of a resource.
 */
  id: string;
}

export function getCaseStateHistory(http: HttpClient, rootUrl: string, params: GetCaseStateHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<CaseStateUpdatesListResponse>> {
  const rb = new RequestBuilder(rootUrl, getCaseStateHistory.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CaseStateUpdatesListResponse>;
    })
  );
}

getCaseStateHistory.PATH = '/api/v1/cases/{id}/state_history';
